import { FC, useState } from "react";
import { Tooltip } from "antd";
import { StyledParagraph } from "./styled";

interface IConditionalTooltipTextProps {
  className?: string;
  rows?: number;
  text: string;
  withoutBreaks?: boolean;
}

export const ConditionalTooltipText: FC<IConditionalTooltipTextProps> = ({
  className,
  rows = 1,
  text,
  withoutBreaks = false,
}) => {
  const [withEllipsis, setWithEllipsis] = useState(false);

  return (
    <Tooltip
      overlay={withEllipsis ? text : ""}
      // withoutBreaks={withoutBreaks}
    >
      <StyledParagraph
        
        style={{ fontWeight: 400}}
        className={className}
        ellipsis={{ rows, onEllipsis: setWithEllipsis }}
      >
        {text}
      </StyledParagraph>
    </Tooltip>
  );
};
